import { DividerVariant } from './divider';

export const getDividerStylesAsClassName = (
  variant: DividerVariant
): string => {
  const variantStyles = {
    gray: 'border-t border-gray-light',
    white: 'border-t border-white',
  };
  const staticStyles = 'border-0 m-0 w-full border-solid';
  const className = `${staticStyles} ${variantStyles[variant]}`;
  return className;
};
